var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatPdf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_131150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_213_131150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79976C5.14879 32 2.99976 29.851 2.99976 27.2V4.8C2.99976 2.14903 5.14879 0 7.79976 0H16.4708C17.7309 0 18.9406 0.495552 19.8385 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8507 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79976C5.48016 31.4 3.59976 29.5196 3.59976 27.2V4.8C3.59976 2.4804 5.48016 0.6 7.79976 0.6H16.4708C17.5734 0.6 18.6318 1.03361 19.4175 1.80722L27.1465 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_213_131150)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_213_131150",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H21C22.6569 14 24 15.3431 24 17V25C24 26.6569 22.6569 28 21 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H21C22.6569 14 24 15.3431 24 17V25C24 26.6569 22.6569 28 21 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#D50B12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H21C23.0987 13.2 24.8 14.9013 24.8 17H23.2C23.2 15.785 22.215 14.8 21 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM24 28H0H24ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM21 13.2C23.0987 13.2 24.8 14.9013 24.8 17V24.2C24.8 26.2987 23.0987 28 21 28C22.215 28 23.2 26.6569 23.2 25V17C23.2 15.785 22.215 14.8 21 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_213_131150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63125 24V17.6H6.03125C6.52292 17.6 6.93542 17.6917 7.26875 17.875C7.60417 18.0583 7.85729 18.3104 8.02813 18.6312C8.20104 18.95 8.2875 19.3125 8.2875 19.7187C8.2875 20.1292 8.20104 20.4937 8.02813 20.8125C7.85521 21.1312 7.6 21.3823 7.2625 21.5656C6.925 21.7469 6.50938 21.8375 6.01563 21.8375H4.425V20.8844H5.85938C6.14688 20.8844 6.38229 20.8344 6.56563 20.7344C6.74896 20.6344 6.88438 20.4969 6.97188 20.3219C7.06146 20.1469 7.10625 19.9458 7.10625 19.7187C7.10625 19.4917 7.06146 19.2917 6.97188 19.1187C6.88438 18.9458 6.74792 18.8115 6.5625 18.7156C6.37917 18.6177 6.14271 18.5687 5.85313 18.5687H4.79063V24H3.63125ZM11.6393 24H9.47053V17.6H11.683C12.3184 17.6 12.8643 17.7281 13.3205 17.9844C13.7789 18.2385 14.1309 18.6042 14.3768 19.0812C14.6226 19.5583 14.7455 20.1292 14.7455 20.7937C14.7455 21.4604 14.6216 22.0333 14.3737 22.5125C14.1278 22.9917 13.7726 23.3594 13.308 23.6156C12.8455 23.8719 12.2893 24 11.6393 24ZM10.6299 22.9969H11.583C12.0289 22.9969 12.4007 22.9156 12.6987 22.7531C12.9966 22.5885 13.2205 22.3437 13.3705 22.0187C13.5205 21.6917 13.5955 21.2833 13.5955 20.7937C13.5955 20.3042 13.5205 19.8979 13.3705 19.575C13.2205 19.25 12.9987 19.0073 12.7049 18.8469C12.4132 18.6844 12.0507 18.6031 11.6174 18.6031H10.6299V22.9969ZM16.0231 24V17.6H20.1231V18.5719H17.1825V20.3094H19.8418V21.2812H17.1825V24H16.0231Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_213_131150",
    x: 1.39976,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_131150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_131150",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_213_131150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_213_131150",
    x: 0,
    y: 14,
    width: 24,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_213_131150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_131150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatPdf.c4de3b0ac66dc8a2f67ac0e36a91740f.svg";